export default __webpack_public_path__ + "static/media/trash.606bb597.png";